import React from 'react';
import classnames from 'classnames/bind';

import { DataWidgetFiltersInput } from 'dashboards/types/filter';

import { Button } from 'components/Button/Button';
import { Icon } from 'components/Icon/IconDeprecated';

import {
  LogicalOperator,
  LogicalOperatorSelect,
} from './LogicalOperatorSelect';
import { DataWidgetFilter } from './DataWidgetFilter';
import { useDataWidgetFiltersInputState } from './context';
import styles from './DataWidgetFiltersInput.module.scss';

const c = classnames.bind(styles);

export function DataWidgetFilterGroup({
  id,
  column,
  operator,
  value,
  and,
  or,
}: DataWidgetFiltersInput) {
  const { addFilter, updateLogicalOperator } = useDataWidgetFiltersInputState();

  const [logicalOperator, setLogicalOperator] = React.useState<LogicalOperator>(
    or ? 'OR' : 'AND'
  );

  function handleAddFilterClick() {
    addFilter(logicalOperator, id);
  }

  return (
    <div className={c('group-item')}>
      <div className={c('group')}>
        <div className={c('group-item')}>
          <LogicalOperatorSelect
            id={`logical-operator-switch-${id}`}
            value={logicalOperator}
            onChange={(logical) => {
              if (logical === 'AND' || logical === 'OR') {
                updateLogicalOperator(logical, id);
                setLogicalOperator(logical);
              }
            }}
          />
        </div>

        <DataWidgetFilter
          key={id}
          id={id}
          column={column}
          operator={operator}
          value={value}
        />

        {and?.map((filter) => <DataWidgetFilter key={filter.id} {...filter} />)}
        {or?.map((filter) => <DataWidgetFilter key={filter.id} {...filter} />)}

        <div className={c('group-item')}>
          <Button
            variant="secondary"
            size="xsmall"
            onClick={handleAddFilterClick}
          >
            <Icon name="plus" size="xsmall" />
            <span>Add filter</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
